import { getUser } from './get'
import { updateNotifications } from '@/libs/api/user/notifications'
import { update } from './update'
import { deleteUser } from './delete'

export default {
  getUser,
  update,
  deleteUser,
  updateNotifications,
}
